import React from "react";
import { Box, Button, Container, Stack, Typography } from "@mui/material";

export type HeroProps = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  ctaLabel?: string;
  ctaHref?: string;
};

// Simple reusable hero section that can be hydrated with WP content later
const HeroSection = ({ eyebrow, title, subtitle, ctaLabel, ctaHref }: HeroProps) => (
  <Box
    component="section"
    sx={{
      py: { xs: 6, md: 10 },
      background: "linear-gradient(120deg, rgba(15, 143, 142, 0.1) 0%, rgba(13, 54, 64, 0.08) 100%)"
    }}
  >
    <Container maxWidth="lg">
      <Stack spacing={2} sx={{ maxWidth: 720 }}>
        {eyebrow ? (
          <Typography variant="overline" sx={{ letterSpacing: "0.2em", fontWeight: 600 }}>
            {eyebrow}
          </Typography>
        ) : null}
        <Typography variant="h1" component="h1">
          {title}
        </Typography>
        {subtitle ? (
          <Typography variant="body1" color="text.secondary">
            {subtitle}
          </Typography>
        ) : null}
        {ctaLabel && ctaHref ? (
          <Box>
            <Button variant="contained" color="primary" href={ctaHref}>
              {ctaLabel}
            </Button>
          </Box>
        ) : null}
      </Stack>
    </Container>
  </Box>
);

export default HeroSection;
